export default __webpack_public_path__ + "static/media/add_treadmill.ddf8373f.svg";